<template>
  <section>
    <div v-if="EChartSettings">
      <v-chart class="chart" :option="EChartSettings" :init-options="initOptions" />
    </div>
  </section>
</template>

<script>
// Component
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import 'zrender/lib/svg/svg'

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  props: {
    title: {
      type: String,
      default: 'Consumo'
    },
    series: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default: () => ['#42A5F5', '#BDBDBD']
    }
  },
  data () {
    return {
      error: false,
      EChartSettings: null,
      initOptions: {
        renderer: 'svg'
      }
    }
  },
  watch: {
    series: {
      immediate: true,
      handler (val) {
        this.renderData(val)
      }
    }
  },
  methods: {
    renderData () {
      this.EChartSettings = {
        title: {
          text: this.title,
          left: 'center'
        },
        tooltip: {
          formatter: function (params) {
            return params.name
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 30,
          data: this.series.map(el => el.name)
        },
        series: [
          {
            name: this.title,
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.series.map((item, index) => ({
              ...item,
              itemStyle: {
                color: this.colors[index % this.colors.length]
              }
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  mounted () {
    this.renderData()
  }
}
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
